import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function SuccessView({ passLabel, amount, leadName, onClose }) {
  return (
    <div
      data-testid="payment-success"
      className="flex flex-col items-center text-center py-8 px-2 animate-fade-up"
    >
      <div className="h-20 w-20 rounded-full bg-[#FF4500]/15 flex items-center justify-center mb-6">
        <CheckCircle2 className="h-11 w-11 text-[#FF4500]" strokeWidth={2.2} />
      </div>
      <h3 className="font-display text-3xl font-800 uppercase tracking-tight text-white">
        You're In!
      </h3>
      <p className="mt-3 text-[#A1A1AA] max-w-sm">
        {leadName ? <>Thanks <span className="text-white font-semibold">{leadName}</span>! Your </> : "Your "}
        <span className="text-white font-semibold">{passLabel}</span> registration is
        confirmed. A confirmation has been recorded
        {amount ? ` for ₹${amount.toLocaleString("en-IN")}` : ""}. See you at the Meraki Moto Mania.
      </p>
      <Button
        data-testid="success-close-button"
        onClick={onClose}
        className="mt-8 rounded-full bg-[#FF4500] hover:bg-[#FF5722] text-white px-10 h-12 text-base font-semibold transition-colors"
      >
        Done
      </Button>
    </div>
  );
}
